import { render, staticRenderFns } from "./ImgCropper.vue?vue&type=template&id=187c12ad&scoped=true&"
import script from "./ImgCropper.vue?vue&type=script&lang=ts&"
export * from "./ImgCropper.vue?vue&type=script&lang=ts&"
import style0 from "./ImgCropper.vue?vue&type=style&index=0&id=187c12ad&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187c12ad",
  null
  
)

export default component.exports